export const PRICE_IMPACT_MAX = 50;
